import React, {useEffect, useCallback} from 'react';
import {getSelectedEffects, swap} from "engine/pads/rack.js";
export const useKeyShortcuts = ({subSequence, setWindowPositions}) => {

    useEffect(() => {
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, []);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'y' && e.metaKey) {
            return;
            let state = subSequence.state;
            e.preventDefault();
            let {selectedElements} = state.windows;

            // find all elements that are effects
            let {rack, effects} = getSelectedEffects(selectedElements, subSequence.getAllEffects());
            if (effects.length >= 2) {
                swap(rack, effects[0], effects[1]);
                let coords1 = {x: effects[0].x, y: effects[0].y};
                let coords2 = {x: effects[1].x, y: effects[1].y};
                let pos = {};
                pos[effects[0].id] = coords2;
                pos[effects[1].id] = coords1;
                setWindowPositions(pos);
                rack.pad.updateEffectRedux();
            }
        }
    }, []);
};
